import { Global } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../../components/SeoHead';
import MainBanner from '../../../components/MainBanner';
import SimpleContent from '../../../components/SimpleContent';

export default function ContractorsPageSubmissionSuccess({
    global,
}) {
    return (
        <>
            <SeoHead
                page_name={`Thank you for downloading your Salary Survey | Science, Engineering & Life Science Recruitment, Jobs & Staffing | SRG`}
                canonical_link={`insights/thank-you-for-downloading-our-salary-survey`}
                robots="noindex, follow"
            />
            <MainBanner
                global={global}
                pathPrefix={`insights.salary_survey_download_success.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>Thank you for downloading our salary survey</h1>
                    </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
                imageALT2={`Overlay Main Banner`}
                displayImage1={false}
            />
            <SimpleContent
                global={global}
                pathPrefix={`insights.salary_survey_download_success.simple_content`}
                customClass={`py-5 text-center`}
                content={
                    <>
                        <p>You've downloaded our salary survey.</p>
                    </>}
                editableText={true}
                buttonTitle1={`Back to jobs`}
                buttonTitleLink1={`/jobs/`}
                buttonTitle2={`Business solutions`}
                buttonTitleLink2={`/employers/`}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();

    return {
        props: {
            global,
        }
    };
}
